import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {CalendarsPanelId} from '../../store/panels/panelStateBase';
import {PopupLargeCalendarsContainer} from '../calendars/popupLargeCalendarsContainer';
import {Frame} from '../common/frames/frame';

interface PopupCalendarViewerProps {
  panelId: CalendarsPanelId;
  onRequestClose: Handler;
}

/*
 * Component.
 */

export const PopupCalendarViewer: FC<PopupCalendarViewerProps> = (props) => {
  const {panelId, onRequestClose} = props;
  return (
    <Frame
      minWidth="540px"
      width={1000}
      height={700}
      shouldForcePopout
      onRequestClose={onRequestClose}
      startHeight={undefined}
      interactionId="popup-viewer-calendar"
    >
      <PopupLargeCalendarsContainer panelId={panelId} />
    </Frame>
  );
};
